import JSONDetailPanel, { type JSONDetailPanelProps } from '@components/JSONDetailPanel'
import { type Person, useAuthPersonInfo } from '@domains/customer-people'

interface CustomerPeopleDetailPanelProps extends JSONDetailPanelProps {
  src: Person
}

export function CustomerPeopleDetailPanel({ src }: CustomerPeopleDetailPanelProps) {
  const { data: authPersonInfo } = useAuthPersonInfo(src.authPersonId)
  if (authPersonInfo) {
    src.authPersonInfo = authPersonInfo
  }

  return <JSONDetailPanel src={src} />
}
